// eslint-disable-next-line no-restricted-imports
import { Tooltip as ArcTooltip, TooltipProps } from 'arc';

type CustomTooltipProps = Omit<TooltipProps, 'content'> & {
    content: React.ReactNode;
};

/**
 * Custom Tooltip wrapper that allows both string and JSX content.
 * Falls back to type cast for JSX until ArcTooltip supports ReactNode.
 */
export function Tooltip(props: CustomTooltipProps) {
    return (
        // @ts-expect-error TODO: Replace once `content` in Arc Tooltip supports ReactNode
        <ArcTooltip {...props} />
    );
}
